// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResult__accountCell___ZbK3H {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.SearchResult__statusBadge___kBMzI {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  white-space: nowrap;
}

.SearchResult__statusBadge___kBMzI::before {
  content: '';
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.SearchResult__statusActive___edOgK {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.SearchResult__statusActive___edOgK::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.SearchResult__statusClosed___zVYK6 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.SearchResult__statusClosed___zVYK6::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.SearchResult__statusClosing___ilKLn {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.SearchResult__statusClosing___ilKLn::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.SearchResult__statusDefault___ts50D {
  color: #5f5f5f;
}

.SearchResult__statusDefault___ts50D::before {
  background: #8a8a8a;
}

.SearchResult__contact___YpQS8 {
  border: 1px solid #E4E4E4;
  border-radius: 3px;
  background-color: #FFF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  margin-bottom: 16px;
}

.SearchResult__contact___YpQS8 table {
    width: 100%;
  }

.SearchResult__contact___YpQS8 table td {
      padding: 18px;
    }

.SearchResult__contact___YpQS8 table th {
      padding: 18px;
      width: 25%;
      text-align: left;
    }

.SearchResult__contact___YpQS8 table thead {
      border-bottom: 1px solid rgba(195, 195, 195, 0.45);
    }

.SearchResult__contact___YpQS8 table tr td:first-child {
        padding-left: 30px;
      }

.SearchResult__contact___YpQS8 table tr th:first-child {
        padding-left: 30px;
      }

.SearchResult__contact___YpQS8 table tbody tr {
        border-bottom: 1px solid rgba(195, 195, 195, 0.45);
      }

.SearchResult__contactHeader____LgXC {
  display: flex;
  background-color: #FAFAFA;
  padding-left: 40px;
  padding-right: 40px;
  border-bottom: 1px solid rgba(195, 195, 195, 0.45);
  position: relative;
}

.SearchResult__contactHeaderRow__name___RiOBa {
  font-size: 18px;
  color: #666;
}

.SearchResult__contactHeaderRow___k4huC {
  flex-grow: 1;
  width: 25%;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #9B9B9B;
  font-size: 14px;
}

.SearchResult__contactHeaderRow___k4huC label {
    font-weight: bold;
    display: block;
    margin-bottom: 8px;
  }

.SearchResult__contactAccountNumber___mX4hA {
  display: inline-block;
  text-transform: uppercase;
  height: 25px;
  padding: 0 10px;
  line-height: 25px;
  text-align: center;
  border-radius: 3px;
  background-color: #376EA1;
  color: white;
  box-sizing: border-box;
  flex: 0 0 auto;
  min-width: 6rem;
  white-space: nowrap;
}

.SearchResult__ticketIcon___m4Bpf {
  margin-left: 10px;
  fill: #E7C76D;
  color: #E7C76D;
}

.SearchResult__refEdit___n18zN {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 28px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;

  position: absolute;
  right: 12px;
  top: 12px;
}

.SearchResult__refEdit___n18zN:hover {
    box-shadow: none;
    background-color: #E1DFE1;
  }

.SearchResult__refEdit___n18zN {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Contacts/components/Search/SearchResult/SearchResult.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mDAAc;AAChB;;AAEA;EACE,wDAAmB;AACrB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,wDAAiB;AACnB;;AAEA;EACE,mDAAmB;AACrB;;AAEA;EACE,wDAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;AAmCrB;;AAjCE;IACE,WAAW;EA+Bb;;AA7BE;MACE,aAAa;IACf;;AAEA;MACE,aAAa;MACb,UAAU;MACV,gBAAgB;IAClB;;AAEA;MACE,kDAAkD;IACpD;;AAGE;QACE,kBAAkB;MACpB;;AAEA;QACE,kBAAkB;MACpB;;AAIA;QACE,kDAAkD;MACpD;;AAKN;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AAOjB;;AALE;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;AAGF;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;;EAOX,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AARE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;AAOF;EACE,yDAAiD;EACjD,qBAAqB;AACvB","sourcesContent":["@value colors: \"styles/colors.css\";\n@value gtRed, gtGreen, gtYellowDark from colors;\n\n.accountCell {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.statusBadge {\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.statusBadge::before {\n  content: '';\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  margin-right: 4px;\n}\n\n.statusActive {\n  color: gtGreen;\n}\n\n.statusActive::before {\n  background: gtGreen;\n}\n\n.statusClosed {\n  color: gtRed;\n}\n\n.statusClosed::before {\n  background: gtRed;\n}\n\n.statusClosing {\n  color: gtYellowDark;\n}\n\n.statusClosing::before {\n  background: gtYellowDark;\n}\n\n.statusDefault {\n  color: #5f5f5f;\n}\n\n.statusDefault::before {\n  background: #8a8a8a;\n}\n\n.contact {\n  border: 1px solid #E4E4E4;\n  border-radius: 3px;\n  background-color: #FFF;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);\n  margin-bottom: 16px;\n\n  table {\n    width: 100%;\n\n    td {\n      padding: 18px;\n    }\n\n    th {\n      padding: 18px;\n      width: 25%;\n      text-align: left;\n    }\n\n    thead {\n      border-bottom: 1px solid rgba(195, 195, 195, 0.45);\n    }\n\n    tr {\n      td:first-child {\n        padding-left: 30px;\n      }\n\n      th:first-child {\n        padding-left: 30px;\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid rgba(195, 195, 195, 0.45);\n      }\n    }\n  }\n}\n\n.contactHeader {\n  display: flex;\n  background-color: #FAFAFA;\n  padding-left: 40px;\n  padding-right: 40px;\n  border-bottom: 1px solid rgba(195, 195, 195, 0.45);\n  position: relative;\n}\n\n.contactHeaderRow__name {\n  font-size: 18px;\n  color: #666;\n}\n\n.contactHeaderRow {\n  flex-grow: 1;\n  width: 25%;\n  padding-top: 25px;\n  padding-bottom: 25px;\n  color: #9B9B9B;\n  font-size: 14px;\n\n  label {\n    font-weight: bold;\n    display: block;\n    margin-bottom: 8px;\n  }\n}\n\n.contactAccountNumber {\n  display: inline-block;\n  text-transform: uppercase;\n  height: 25px;\n  padding: 0 10px;\n  line-height: 25px;\n  text-align: center;\n  border-radius: 3px;\n  background-color: #376EA1;\n  color: white;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  min-width: 6rem;\n  white-space: nowrap;\n}\n\n.ticketIcon {\n  margin-left: 10px;\n  fill: #E7C76D;\n  color: #E7C76D;\n}\n\n.refEdit {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 28px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    box-shadow: none;\n    background-color: #E1DFE1;\n  }\n\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n\n.refEdit {\n  background-image: url(\"styles/img/icon_edit.png\");\n  background-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"accountCell": `SearchResult__accountCell___ZbK3H`,
	"statusBadge": `SearchResult__statusBadge___kBMzI`,
	"statusActive": `SearchResult__statusActive___edOgK`,
	"statusClosed": `SearchResult__statusClosed___zVYK6`,
	"statusClosing": `SearchResult__statusClosing___ilKLn`,
	"statusDefault": `SearchResult__statusDefault___ts50D`,
	"contact": `SearchResult__contact___YpQS8`,
	"contactHeader": `SearchResult__contactHeader____LgXC`,
	"contactHeaderRow__name": `SearchResult__contactHeaderRow__name___RiOBa`,
	"contactHeaderRow": `SearchResult__contactHeaderRow___k4huC`,
	"contactAccountNumber": `SearchResult__contactAccountNumber___mX4hA`,
	"ticketIcon": `SearchResult__ticketIcon___m4Bpf`,
	"refEdit": `SearchResult__refEdit___n18zN`
};
export default ___CSS_LOADER_EXPORT___;
